import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode8({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="BOS DUGME" />
}
